<template>
    <section>
        <div class="header-line">
            <h3 class="profile-label">
                Linked Contacts
            </h3>
        </div>

        <div>
            <template v-if="isContactHasRecords" lang="html">
                <div data-qa="linked-contacts-table">
                    <ds-table-grid
                        ref="table"
                        :data="linkedContacts"
                        align="center"
                        data-qa="linked-contacts-grid"
                    >
                        <ds-table-grid-column
                            label="Name"
                            prop="name"
                            width="200"
                        >
                            <template slot-scope="linkedContact">
                                <span class="contact-display-data" :title="fullName(linkedContact)">
                                    <a class="open-contact" @click="openContact(linkedContact.linkedId)">{{ fullName(linkedContact) }}</a>
                                </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Type"
                            width="200"
                            prop="Type"
                        >
                            <template slot-scope="linkedContact">
                                <span class="contact-display-data" :title="linkedContact.type"> {{ linkedContact.type }} </span>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Add Tasks"
                            width="150"
                            prop="AddTasks"
                        >
                            <template slot-scope="linkedContact">
                                <ds-icon-button
                                    @click="openTask(linkedContact)"
                                >
                                    <ds-icon class="check" name="check" />
                                </ds-icon-button>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Send Email"
                            width="150"
                            prop="SendEmail"
                        >
                            <template slot-scope="linkedContact">
                                <ds-icon-button
                                    v-if="showEmailSendButton(linkedContact)"
                                    @click.native.stop="launchBardEmailBroadcast(linkedContact)"
                                >
                                    <ds-icon
                                        name="send"
                                        class="external-look"
                                    />
                                </ds-icon-button>

                                <ds-tooltip v-if="!showEmailSendButton(linkedContact)" position="left">
                                    <template #reference>
                                        <ds-icon-button
                                            class="icon-only"
                                        >
                                            <ds-icon
                                                class="disable-send-button"
                                                name="send"
                                            />
                                        </ds-icon-button>
                                    </template>

                                    <template #default>
                                        <div>Email does not exist</div>
                                    </template>
                                </ds-tooltip>
                            </template>
                        </ds-table-grid-column>

                        <ds-table-grid-column
                            label="Remove"
                            width="150"
                            prop="Remove"
                            data-qa="remove"
                        >
                            <template slot-scope="linkedContact" data-qa="remove-link">
                                <ds-icon-button class="remove-linked-contact" @click="removeLinkedContact(linkedContact)">
                                    <img
                                        alt="Remove Linked contact"
                                        src="/resources/funnel/images/svg/minus.svg"
                                        onmouseover="this.src='/resources/funnel/images/svg/click.svg'"
                                        onmouseout="this.src='/resources/funnel/images/svg/minus.svg'"
                                    />
                                </ds-icon-button>
                            </template>
                        </ds-table-grid-column>
                    </ds-table-grid>
                </div>
            </template>

            <div v-if="!isContactHasRecords" class="no-records-section">
                <p class="no-records-label">
                    No records to display
                </p>
            </div>
        </div>
        <div class="header-line">
            <h3 class="profile-label">
                Create Linked Contact
            </h3>

            <div class="input-row">
                <ds-outline-button data-qa="save-link-contact" @click="saveLink">
                    Save Link
                </ds-outline-button>
            </div>
        </div>

        <div>
            <div class="create-contact-link">
                <p class="heading-contact-link">
                    Contact to Link
                </p>

                <div v-if="showContactLinkInputField" class="create-contact-link">
                    <ds-input-field
                        v-model="searchContact"
                        class="select-created-linked-contact"
                        data-qa="search-contact-input"
                    />

                    <ds-outline-button class="search-manage-button" data-qa="search-contact" @click="search">
                        search
                    </ds-outline-button>
                </div>

                <div v-if="!showContactLinkInputField" data-qa="select-contact-link">
                    <p>{{ selectedContact.firstName }}<a @click="search"> (Select a different contact...)</a></p>

                    <p>{{ selectedContact.email }}</p>

                    <p>{{ selectedContact.phone1 }}</p>
                </div>
            </div>

            <div class="create-contact-link">
                <p class="heading-type-link">
                    Type of Link
                </p>

                <ds-select-field
                    v-model="selectedType"
                    bind-value-only
                    class="select-created-linked-contact"
                    label="Please select one"
                    :options="typeOfLinks"
                />

                <ds-outline-button class="search-manage-button" data-qa="manage-link-types" @click="manageLink">
                    Manage Link Types
                </ds-outline-button>
            </div>
        </div>

        <contact-manage-link-types ref="manageLinkTypes" @backToLinkedContacts="backToLinkedContacts" />

        <contact-modal ref="contactModalPopUp" @selectedContact="contactSelected" />

        <task-form ref="taskFormRef" :user-id="userId" :contact="addTaskContact" />

        <ds-modal :is-open="isValidationModalOpen" dialog>
            <p v-if="contactNotSelected" data-qa="choose-contact">
                Please choose a contact to link
            </p>

            <p v-if="typeNotSelected" data-qa="choose-link-type">
                Please choose a link type
            </p>

            <ds-filled-button data-qa="close-modal-dialog" @click="closeValidationModal">
                Close
            </ds-filled-button>
        </ds-modal>
    </section>
</template>
<script>
import axios from 'axios';
import ContactModal from './ContactModal';
import ContactManageLinkTypes from './ContactManageLinkTypes';
import TaskForm from './TaskForm';

export default {

    components: {
        ContactModal,
        ContactManageLinkTypes,
        TaskForm,
    },

    props: {
        contact: Object,
        userId: [String, Number],
        backUrl: String,
    },

    data() {
        return {
            showContactLinkInputField: true,
            linkedContacts: [],
            typeOfLinks: [],
            selectedType: 0,
            searchContact: '',
            selectedContact: {},
            addTaskContact: {},
            featureFlagValues: [],
            isBardBuilderEnabled: false,
            isValidationModalOpen: false,
        };
    },

    created() {
        this.getFeatureFlagValue();
        this.init();
    },

    computed: {

        fullName() {
            return (linkedContact) => {
                return `${linkedContact?.firstName} ${linkedContact?.lastName}`;
            };
        },

        showEmailSendButton() {
            return (linkedContact) => {
                return linkedContact?.email !== '';
            };
        },

        isContactHasRecords() {
            return this.linkedContacts?.length > 0;
        },

        contactNotSelected() {
            return Object.keys(this.selectedContact).length === 0;
        },

        typeNotSelected() {
            return this.selectedType === 0;
        },

        showDialog() {
            return this.contactNotSelected || this.typeNotSelected;
        },
    },

    methods: {
        init() {
            this.loadLinkedContacts();
            this.loadMangeLinksById();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/broadcast/getFeatureflags');

                this.featureFlagValues = response.data;
                this.isBardBuilderEnabled = this.featureFlagValues.isBardBuilderEnabled;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },

        async launchBardEmailBroadcast(linkedContact) {
            try {
                const response = await axios.post(`/app/emailBroadcast/createListForContact?contactId=${linkedContact?.linkedId}&emailAddress=${linkedContact.email}`);

                if (window.sessionStorage) {
                    sessionStorage.setItem('fromContact', true);
                    sessionStorage.setItem('contactId', linkedContact?.linkedId);
                    sessionStorage.setItem('backUrl', this.backUrl);

                    if (this.isBardBuilderEnabled) {
                        window.location = `/app/email/broadcast/gallery?listId=${response.data}`;
                    } else {
                        this.contactEmail(linkedContact.email);
                    }
                }
            } catch (error) {
                this.$error({ message: 'error while loading Contact email Details' });
            }
        },

        async contactEmail(email) {
            try {
                const response = await axios.get('/app/contact/emailId');

                const templateData = response.data;

                window.open(`/Mail/compose.jsp?id=${templateData?.mailId}&templateid=${
                        templateData?.templateId}&Mail0ToAddress_text=${
                    email}&mergeid=${this.contact?.id}`);
            } catch (error) {
                this.$error({ message: 'error while loading Contact email Details' });
            }
        },

        openValidationModal() {
            this.isValidationModalOpen = true;
        },

        closeValidationModal() {
            this.isValidationModalOpen = false;
        },

        contactSelected(contact) {
            this.selectedContact = contact;
            this.showContactLinkInputField = false;
            this.searchContact = '';
        },

        openContact(linkedId) {
            window.location = `/Contact/manageContact.jsp?view=edit&ID=${linkedId}`;
        },

        manageLink() {
            this.$refs.manageLinkTypes.loadManageLinkTypes();
        },

        search() {
            this.$refs.contactModalPopUp.loadContacts(this.searchContact);
        },

        backToLinkedContacts(reload) {
            if (reload) {
                this.loadMangeLinksById();
            }
        },

        saveLink() {
            if (this.showDialog) {
                this.openValidationModal();
            } else {
                this.saveLinkedContact();
            }
        },

        async saveLinkedContact() {
            try {
                const linkedContactId = this.selectedContact.id;
                const contactId = this.contact.id;
                const linkedTypeId = this.selectedType;

                await axios.post(`/app/contact/saveLinkedContact/${linkedContactId}/${contactId}/${linkedTypeId}`);
                this.selectedContact = {};
                this.selectedType = 0;
                this.showContactLinkInputField = true;
                const successMessage = 'Contact linked successfully';

                this.$toast({ message: successMessage });
                this.init();
            } catch (error) {
                this.$error({ message: 'error occurred while linking contacts' });
            }
        },

        async removeLinkedContact(linkedContact) {
            try {
                await axios.delete(`/app/contact/removeLinkedContact/${linkedContact.linkedContactId}`);

                const successMessage = 'Linked contacts removed successfully';

                this.$toast({ message: successMessage });
                this.init();
            } catch (error) {
                this.$error({ message: 'error occurred while removing linked contacts' });
            }
        },

        async openTask(task) {
            this.addTaskContact = {
                firstName: task.firstName,
                lastName: task.lastName,
                id: task.linkedId,
            };
            await this.$nextTick(() => {
                this.$refs.taskFormRef.showModal(0);
            });
        },

        async loadLinkedContacts() {
            try {
                const response = await axios.get(`/app/contact/getLinkedContacts/${this.contact?.id}`);

                this.linkedContacts = response.data;
            } catch (error) {
                this.$error({ message: 'error occurred while getting linked Contacts data' });
            }
        },

        async loadMangeLinksById() {
            try {
                const response = await axios.get(`/app/contact/getTypeOfLinks/${this.contact?.id}`);

                this.typeOfLinks = response.data;

                this.typeOfLinks = Object.keys(this.typeOfLinks).map((key) => {
                    return { label: this.typeOfLinks[key], value: Number(key) };
                }).sort((prev, next) => prev.label.localeCompare(next.label));
            } catch (error) {
                this.$error({ message: 'error occurred while loading manage links dropdown' });
            }
        },
    },
};

</script>
<style lang="scss" scoped>
.header-line {
    justify-content: space-between;
    width: 100%;
    display: flex;
    margin-top: $spacing-250;
    margin-bottom: $spacing-250;
}

.input-row {
    width : auto;
}

.remove-linked-contact{
    padding: 0;
}

.select-created-linked-contact {
    width: px-to-rem(320px);
    margin-right: $spacing-400;
    @media($small) {
        width: auto;
    }
}

.create-contact-link {
    display: flex;
    align-items: baseline;
}

.heading-contact-link {
    margin-right: $spacing-400;
}

.heading-type-link {
    margin-right: 3.2rem;
}

.open-contact {
    color: $color-blue !important;
}

.no-records-section {
    width: 100%;
    text-align: center;
    border-top: 1px solid $color-gray-lighter;
    margin-top:  $spacing-200;
    border-bottom: 1px solid $color-gray-lighter;
}

.no-records-label {
    color: $color-gray-darker;
    font-size: $font-size-lg;
    font-weight: 300;
    padding-top: $spacing-800;
    padding-bottom: $spacing-600;
}

.search-manage-button {
    place-self: baseline;
}

.external-look {
    --icon-color: #{$color-blue};
    cursor: pointer;
}

.icon-only {
    cursor: default;
}

.disable-send-button {
    --icon-color: #{$color-gray-500};
}

.contact-display-data {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    @media($small) {
        width: 11rem;
    }
}
</style>
